import React, { useState } from "react";
import { Modal } from "../../Components";

function Policy({ className = "" }) {
	const [ViewPolicy, setViewPolicy] = useState(null);

	return (
		<>
			<div className={`gap-4 flex-center ${className}`}>
				<div onClick={() => setViewPolicy("terms")} className="cursor-pointer text-label">
					Terms & Conditions
				</div>
			</div>
			<Modal contentClass="!max-w-[70%]" open={ViewPolicy} onClose={() => setViewPolicy(null)}>
				<div className="h-[90vh] overflow-hidden rounded-lg w-full">
					<iframe title="Terms of Service" src="https://www.travelwingsforbusiness.com/terms-conditions/" className="w-full h-full" />
				</div>
			</Modal>
		</>
	);
}

export default Policy;
